import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Avatar } from 'antd';

import { IconEdit } from '../../../../../../../data/assets/icons';
import { getAvatarBgClass, formatDate } from '../../../../../../../data/config/utils';

import ProfileAvatar from '../../../../../../../components/profileavatar'
import InlineItem from '../../../../../../../components/inlineitem';

class GroupDetailCard extends React.PureComponent {
  state = {
    show_all_members: false,
    display_members_count: 4,
  };

  onClickEditGroup = () => {
    const { group, onClickEdit } = this.props;
    onClickEdit(group);
  };

  showAllMembers = () => {
    const { group } = this.props;
    this.setState({ show_all_members: true, display_members_count: group.agents.length });
  };

  showLessMembers = () => {
    this.setState({ show_all_members: false, display_members_count: 4 });
  };

  render() {
    const { group, empty_member_message, onClickEdit } = this.props;
    const { show_all_members, display_members_count } = this.state;
    return (
      <div className="ori-animated ori-fade-in ori-relative">
        {
          onClickEdit &&
          <div className="ori-absolute ori-align-right ori-align-top ori-pad-10 ori-font-light-hover-primary" onClick={this.onClickEditGroup}>
            <IconEdit size={18} />
          </div>
        }
        <div className="ori-flex-column ori-flex-ac ori-flex-jc ori-tb-pad-15">
          <Avatar className={classNames("ori-border-white", { ...getAvatarBgClass(group.name) })} size={80} icon="team" />
          <p className="ori-font-md ori-text-overflow-dotted ori-uppercase ori-tb-mrgn-10">{group.name}</p>
          {
            group.description &&
            <p className="ori-font-sm ori-b-mrgn-10">{group.description}</p>
          }
        </div>
        {
          onClickEdit &&
          <div className="ori-b-mrgn-10 ori-bg-white ori-pad-10 ori-border-radius-4">
            <p className="ori-text-overflow-dotted ori-uppercase ori-font-bold ori-b-mrgn-5">Informations</p>
            <div className="ori-lr-pad-10 ori-tb-pad-5 ori-bg-default">
              <InlineItem title="created by" info={group.createdBy} size="small" />
              <InlineItem title="created At" info={formatDate(group.createdAt, { year: "numeric", month: "short", day: "numeric" })} size="small" />
              <InlineItem title="last updated by" info={group.lastUpdatedBy} size="small" />
              <InlineItem title="last updated At" info={formatDate(group.updatedAt, { year: "numeric", month: "short", day: "numeric" })} size="small" />
            </div>
          </div>
        }
        <div className="ori-b-mrgn-10 ori-bg-white ori-pad-10 ori-border-radius-4">
          <p className="ori-text-overflow-dotted ori-uppercase ori-font-bold ori-b-mrgn-5">members</p>
          <div className="ori-lr-pad-10 ori-tb-pad-5 ori-bg-default">
            {
              group.agents && group.agents.map((member, index) => {
                if (index < display_members_count) {
                  return (
                    <div key={index} className="ori-tb-pad-5 ori-b-border-light-last-none">
                      <ProfileAvatar size="small" title_class="ori-font-xs" title={`${member.firstName} ${member.lastName}`} />
                    </div>
                  );
                }
                return null;
              })
            }
            {
              (!group.agents || (group.agents && group.agents.length === 0)) &&
              <span className="ori-t-mrgn-5 ">{empty_member_message}</span>
            }
            {
              group.agents && group.agents.length > display_members_count && !show_all_members &&
              <span className="ori-font-primary ori-cursor-ptr ori-t-mrgn-5 ori-font-xs" onClick={this.showAllMembers}>{`show ${group.agents.length - 4} more `}</span>
            }
            {
              group.agents && group.agents.length >= display_members_count && show_all_members &&
              <span className="ori-font-primary ori-cursor-ptr ori-t-mrgn-5 ori-font-xs" onClick={this.showLessMembers}>show less</span>
            }
          </div>
        </div>
      </div>
    );
  }
}

GroupDetailCard.propTypes = {
  group: PropTypes.object,
  empty_member_message: PropTypes.string,
  onClickEdit: PropTypes.func,
};

GroupDetailCard.defaultProps = {
  group: {},
  empty_member_message: "There is no any member in this group. click on edit icon to edit and add members in the group."
};

export default GroupDetailCard;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/groups/components/groupdetailcard/index.js